import React, { useEffect, useState } from "react";
import CustomModal from "../../shared/CustomModal";
import Button from "../../shared/Button";
import { useSubjectArea } from "../../../hooks/useSubjectArea";
import { Spinner } from "reactstrap";
import swal from "sweetalert";
import PermissionButton from "../../shared/PermissionButton";
import { checkRolePermissions } from "../../../../../utils/Constants";
import Pagination from "../../../../../components/UI/Pagination";

const ListSubjectArea = ({ name: widgetName }) => {
  const {
    subjectArea,
    totalRecordsCount,
    loading,
    updateSubjectArea,
    deleteSubjectArea,
    refetch,
  } = useSubjectArea(10);
  const [pageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteModal, setDeleteModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [selectedSubjectArea, setSelectedSubjectArea] = useState(null);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [permission, setPermission] = useState({
    permissionEditSubjectArea: false,
    permissionDeleteSubjectArea: false,
  });

  const handleSubjectAreaUpdate = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      swal("Oops", "Name is required");
      return;
    }

    const data = {
      id: selectedSubjectArea.id,
      name: name.trim(),
      description: description?.trim(),
    };

    try {
      await updateSubjectArea(data);
      refetch(currentPage);
      setUpdateModal(false);
    } catch (error) {
      console.error("Update failed:", error);
    }
  };

  const checkPermissions = () => {
    setPermission({
      permissionEditSubjectArea: checkRolePermissions(
        "edit-subject-area",
        "activity",
        widgetName,
      ),
      permissionDeleteSubjectArea: checkRolePermissions(
        "delete-subject-area",
        "activity",
        widgetName,
      ),
    });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    refetch(page);
  };

  const handleNextPage = () => {
    const totalPages = Math.ceil(totalRecordsCount / pageSize);
    if (currentPage < totalPages) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      refetch(nextPage);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      const prevPage = currentPage - 1;
      setCurrentPage(prevPage);
      refetch(prevPage);
    }
  };

  const handleDeleteSubectArea = async () => {
    try {
      await deleteSubjectArea(selectedSubjectArea.id);
      setSelectedSubjectArea(null);
      setDeleteModal((prev) => !prev);
      const updatedTotalRecordsCount = totalRecordsCount - 1;
      const totalPages = Math.ceil(updatedTotalRecordsCount / pageSize);
      let page = currentPage;
      if (page > 1 && page > totalPages) {
        page = page - 1;
        setCurrentPage(page);
      }
      refetch(page);
    } catch (error) {
      console.error("Delete Failed: ", error);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, []);

  return (
    <>
      <div className="arr-content">
        <div className="arr-heading">
          <h1>List Subject Area</h1>
          <div className="arr-btns-group">
            <PermissionButton
              widgetName={widgetName}
              moduleName={"Subjets Setup"}
              activityName={"select-subject-area"}
              header={"List Subject Area"}
            />
          </div>
        </div>
        <div className="arr-table-container">
          <table aria-label="subject-table" className="arr-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Subject Area</th>
                <th>Description</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {loading.read ? (
                <tr>
                  <td colSpan={4}>
                    <div className="arr-spinner">
                      <div className="loader">
                        <Spinner size={"md"} color="primary"></Spinner>
                      </div>
                      <div style={{ fontSize: "13px", marginTop: "15px" }}>
                        Please wait !! Processing.....
                      </div>
                    </div>
                  </td>
                </tr>
              ) : subjectArea.length > 0 ? (
                subjectArea?.map((item, idx) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * pageSize + idx + 1}</td>
                    <td>{item.name}</td>
                    <td>{item.description || "No Description Available"}</td>
                    <td className="action-btns">
                      {permission.permissionEditSubjectArea && (
                        <Button
                          size={"sm"}
                          variant={"outline"}
                          onClick={() => {
                            setUpdateModal((prev) => !prev);
                            setSelectedSubjectArea(item);
                            setName(item.name);
                            setDescription(item?.description);
                          }}
                        >
                          Update
                        </Button>
                      )}
                      {permission.permissionDeleteSubjectArea && (
                        <Button
                          onClick={() => {
                            setDeleteModal((prev) => !prev);
                            setSelectedSubjectArea(item);
                          }}
                          size={"sm"}
                          variant={"danger"}
                        >
                          Delete
                        </Button>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} style={{ textAlign: "center" }}>
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div
          className="modern-pagination"
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "48px",
          }}
        >
          <Pagination
            type="modern"
            itemsCount={totalRecordsCount}
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            nextPage={handleNextPage}
            previousPage={handlePreviousPage}
          />
        </div>
      </div>

      {/* delete modal */}
      <CustomModal
        isOpen={deleteModal}
        toggle={() => setDeleteModal((prev) => !prev)}
        modalHeader={"Are you sure?"}
        children={
          <div>
            <p>Once Deleted, you will not be able to recover this record</p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
                gap: "8px",
              }}
            >
              <Button
                variant="outline"
                onClick={() => setDeleteModal((prev) => !prev)}
              >
                Cancel
              </Button>
              <Button
                variant="danger"
                disabled={loading.delete}
                onClick={handleDeleteSubectArea}
              >
                {loading.delete ? (
                  <Spinner size={"sm"} color="white" />
                ) : (
                  "Delete"
                )}
              </Button>
            </div>
          </div>
        }
      />

      {/* update modal */}
      <CustomModal
        isOpen={updateModal}
        toggle={() => setUpdateModal((prev) => !prev)}
        modalHeader={"Update Subject Area"}
        children={
          <form
            onSubmit={handleSubjectAreaUpdate}
            className="arr-form grid noShadow"
          >
            <div className="form-input">
              <label className="required" htmlFor="name">
                Name of Subject Area
              </label>
              <input
                value={name}
                className="form-control"
                onChange={(e) => setName(e.target.value)}
                type="text"
                name="name"
                id="name"
              />
            </div>
            <div className="form-input">
              <label htmlFor="description">Description</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="form-control"
                type="text"
                name="description"
                id="description"
              />
            </div>
            <div className="action-btns end">
              <Button
                variant="outline"
                onClick={() => setUpdateModal((prev) => !prev)}
              >
                Cancel
              </Button>
              <Button type="submit" disabled={loading.update}>
                {loading.update ? (
                  <Spinner size={"sm"} color="white" />
                ) : (
                  "Update"
                )}
              </Button>
            </div>
          </form>
        }
      />
    </>
  );
};

export default ListSubjectArea;
